import React, { useState, useEffect } from "react";
import { Button, Row, Col, Form, Image } from "react-bootstrap";
import {
  TextField,
  IconButton,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core";
import { Scrollbars } from "react-custom-scrollbars";
import Switch from "react-switch";
import {
  getCrusines,
  getFavChains,
  getFavPlaces,
  checkIfEmailExists,
  checkIfPhoneExists,
  getDietaryPref,
  getAllergies,
  editStep1,
  editStep2,
  editStep3,
  editStep4,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFormik } from "formik";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import * as yup from "yup";
import Alert from "react-s-alert";
//const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validationSchema = yup.object({
  mobile_number: yup.string().required("Phone number is required"),
  // /.matches(phoneRegExp, "Phone number is not valid")
  // .min(10, "to short")
  // /.max(10, "to long"),
  email: yup
    .string()
    .email("Please enter valid Email address")
    .required("Please enter your email"),
  country: yup.string().required("Please select country"),
  state: yup.string().required("Please select state"),
  city: yup.string().required("Please select city"),
});

const validate = (values) => {
  const errors = {};

  if (values.birthday_day) {
    if (!values.birthday_month) {
      errors.birthday_month = "Please enter month";
    }
    if (values.birthday_day > 31 || values.birthday_day === 0) {
      errors.birthday_day = "Date should be between 1-31";
    }
  }
  if (values.birthday_month) {
    if (!values.birthday_day) {
      errors.birthday_day = "Please enter day";
    }
    if (values.birthday_month > 12 || values.birthday_month === 0) {
      errors.birthday_month = "Month should be between 1-12";
    }
  }
  if (values.anniversary_day) {
    if (!values.anniversary_month) {
      errors.anniversary_month = "Please enter month";
    }
    if (values.anniversary_day > 31 || values.anniversary_day === 0) {
      errors.anniversary_day = "Date should be between 1-31";
    }
  }
  if (values.anniversary_month) {
    if (!values.anniversary_day) {
      errors.anniversary_day = "Please enter day";
    }
    if (values.anniversary_month > 12 || values.anniversary_month === 0) {
      errors.anniversary_month = "Month should be between 1-12";
    }
  }
  return errors;
};

const EditUser = (props) => {
  const [ShowTab, setShowTab] = useState("1");
  // const [checkedBox, setCheckedBox] = useState(false);

  const handleShowTab = (e) => setShowTab(e);
  // const handleChangeSwitch = (e) =>
  //   setCheckedBox({ checkedBox: !checkedBox.checkedBox });

  const [state, setState] = useState({
    code: props.auth.user.VendorUser.country_code,
    Language: "English",
  });
  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };
  const formik = useFormik({
    initialValues: {
      birthday_day: "",
      birthday_month: "",
      anniversary_day: "",
      anniversary_month: "",
      email: "",
      mobile_number: "",
      address: "",
      city: "",
      state: "",
      country: "",
      country_id: "",
      state_id: "",
      city_id: "",
    },
    validate,
    validationSchema,

    onSubmit: (values) => {
      var email = {};
      email.email = values.email;

      var phone = {};
      phone.phone = values.mobile_number;
      //formik.errors.email = "email is already registered";
      const onSuccessEmailStatus = (status) => {
        if (status.status) {
          Alert.error(`<h4>Email is already registered</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (props.data.mobile_number === values.mobile_number) {
          props.editStep1(props.data._id, values, onSuccessUpdate);
        } else {
          props.checkIfPhoneExists(phone, onSuccessPhoneStatus);
        }
      };
      const onSuccessPhoneStatus = (status) => {
        if (status.status) {
          // formik.errors.email = "email is already registered";
          Alert.error(`<h4>Phone no is already registered</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          props.editStep1(props.data._id, values, onSuccessUpdate);
        }
      };
      if (props.data.email !== values.email) {
        props.checkIfEmailExists(email, onSuccessEmailStatus);
      } else if (props.data.mobile_number !== values.mobile_number) {
        props.checkIfPhoneExists(phone, onSuccessPhoneStatus);
      } else {
        props.editStep1(props.data._id, values, onSuccessUpdate);
      }
    },
  });

  // step 2

  const [tempInput, setTempInput] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const handleAddFields = () => {
    const values = [];
    values.push({
      special_occasion: "",
      special_occasion_day: "",
      special_occasion_month: "",
    });
    setTempInput(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...tempInput];
    if (event.target.name === "special_occasion") {
      values[index].special_occasion = event.target.value;
    } else if (event.target.name === "special_occasion_day") {
      values[index].special_occasion_day = event.target.value;
    } else {
      values[index].special_occasion_month = event.target.value;
    }

    setTempInput(values);
  };

  const [dynamicId, SetDynamicId] = useState(1);

  const onAddOccassion = (e) => {
    e.preventDefault();
    var id = dynamicId + 1;
    tempInput[0]._id = id;
    setInputFields([...inputFields, tempInput[0]]);
    SetDynamicId(id);
    setTempInput([]);
  };
  const removeOccasion = (index) => {
    var filterOcassion = [...inputFields];
    filterOcassion.splice(index, 1);
    setInputFields(filterOcassion);
  };

  //step 3

  const [days, setDays] = useState([
    { name: "Mon", status: false },
    { name: "Tue", status: false },
    { name: "Wed", status: false },
    { name: "Thu", status: false },
    { name: "Fri", status: false },
    { name: "Sat", status: false },
    { name: "Sun", status: false },
    { name: "All", status: false },
  ]);

  const daysEatOut = () => {
    var data = props.data.day_you_eat_out;
    var pushTrueDays = [];
    for (var i = 0; i < days.length; i++) {
      if (data.includes(days[i].name)) {
        pushTrueDays.push({ name: days[i].name, status: true });
      } else {
        pushTrueDays.push({ name: days[i].name, status: false });
      }
    }
    setDays(pushTrueDays);
  };

  const onChangeDaysEatOut = (day) => {
    if (day.name === "All") {
      //setRemoveOtherDays(false);
      var removeOtherDays = days.map((data) => {
        if (data.name !== "All") {
          return { ...data, status: false };
        } else {
          return { ...data, status: true };
        }
      });
      setDays(removeOtherDays);
      //setDaysEatOut([day.name]);
    } else {
      var changeDayStatus = days.map((data) => {
        if (data.name === day.name) {
          return { ...data, status: !data.status };
        } else if (data.name === "All") {
          return { ...data, status: false };
        } else {
          return { ...data };
        }
      });
      setDays(changeDayStatus);
    }
  };

  const [popularCuisines, setPopularCrusines] = useState([]);
  const [selectedCruisines, setSelectedCrusines] = useState([]);

  const onChangeAddCrusines = (item, id) => {
    var statusChange = popularCuisines.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });
    setPopularCrusines(statusChange);
    const data = [];
    data.name = item;
    data.id = id;
    setSelectedCrusines([...selectedCruisines, data]);
  };
  const onRemoveCruises = (id) => {
    var statusChange = popularCuisines.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setPopularCrusines(statusChange);
    var filteredCruises = selectedCruisines.filter(
      (crusine) => crusine.id !== id
    );
    setSelectedCrusines(filteredCruises);
  };

  const [favPlaces, setFavPlaces] = useState([]);
  const [selectedFavPlaces, setSelectedFavPlaces] = useState([]);

  const onChangeAddFavPlaces = (item, id) => {
    var statusChange = favPlaces.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setFavPlaces(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedFavPlaces([...selectedFavPlaces, data1]);
  };
  const onRemoveFavPlaces = (id) => {
    var statusChange = favPlaces.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setFavPlaces(statusChange);
    var filteredFavPlaces = selectedFavPlaces.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedFavPlaces(filteredFavPlaces);
  };

  const onSuccessGetCrusines = (data) => {
    var crusines = [];
    var dataToInsert = [];

    setSelectedCrusines([...selectedCruisines, data]);
    for (var i = 0; i < data.length; i++) {
      if (props.data.selected_cuisine.includes(data[i]._id)) {
        dataToInsert.push({ id: data[i]._id, name: data[i].title });
        crusines.push({ name: data[i].title, status: true, id: data[i]._id });
      } else {
        crusines.push({ name: data[i].title, status: false, id: data[i]._id });
      }
    }
    setSelectedCrusines(dataToInsert);
    setPopularCrusines(crusines);
  };

  const onErrorGetCruisnes = () => {};

  const onSuccessGetFavPlaces = (data) => {
    let fav = [];
    let dataToInsert = [];

    for (let i = 0; i < data.length; i++) {
      if (props.data.favourite_places.includes(data[i]._id)) {
        dataToInsert.push({ id: data[i]._id, name: data[i].title });
        fav.push({ name: data[i].title, status: true, id: data[i]._id });
      } else {
        fav.push({ name: data[i].title, status: false, id: data[i]._id });
      }
    }
    setSelectedFavPlaces(dataToInsert);
    setFavPlaces(fav);
  };

  const onErrorGetFavPlaces = () => {};

  //step last

  const [favChains, setFavChains] = useState([]);
  const [selectedFavChains, setSelectedFavChains] = useState([]);

  const onChangeAddFavChains = (item, id, icon) => {
    var statusChange = favChains.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setFavChains(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    data1.icon = icon;
    setSelectedFavChains([...selectedFavChains, data1]);
  };
  const onRemoveFavChains = (id) => {
    var statusChange = favChains.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setFavChains(statusChange);
    var filteredFavChains = selectedFavChains.filter(
      (favChains) => favChains.id !== id
    );
    setSelectedFavChains(filteredFavChains);
  };
  const onSuccessGetFavChain = (data) => {
    var favC = [];
    var dataToInsert = [];
    for (var i = 0; i < data.length; i++) {
      if (props.data.selected_chain.includes(data[i]._id)) {
        favC.push({
          name: data[i].title,
          status: true,
          id: data[i]._id,
          icon: data[i].icon,
        });
        dataToInsert.push({
          id: data[i]._id,
          name: data[i].title,
          icon: data[i].icon,
        });
      } else {
        favC.push({
          name: data[i].title,
          status: false,
          id: data[i]._id,
          icon: data[i].icon,
        });
      }
    }

    setSelectedFavChains(dataToInsert);
    setFavChains(favC);
  };

  const onErrorGetFavChain = () => {};

  const onChangeAddDietaryPref = (item, id) => {
    var statusChange = dietaryPref.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setDietaryPref(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedDietaryPref([...selectedDietaryPref, data1]);
  };
  const onRemoveDietaryPref = (id) => {
    var statusChange = dietaryPref.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setDietaryPref(statusChange);
    var filteredDietPref = selectedDietaryPref.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedDietaryPref(filteredDietPref);
  };

  const [checkboxDietary, setCheckedBoxDietary] = useState(false);
  const handleChangeSwitchDietary = (e) => {
    setCheckedBoxDietary({ checkboxDietary: !checkboxDietary.checkboxDietary });
  };

  const [checkedBoxAllergies, setCheckedBoxAllergies] = useState(false);
  const handleChangeSwitchAllergies = (e) => {
    setCheckedBoxAllergies({
      checkedBoxAllergies: !checkedBoxAllergies.checkedBoxAllergies,
    });
  };

  const onChangeAddAllergies = (item, id) => {
    let statusChange = allergies.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setAllergies(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedAllergies([...selectedAllergies, data1]);
  };
  const onRemoveAllergies = (id) => {
    let statusChange = allergies.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setAllergies(statusChange);
    let filteredAllergies = selectedAllergies.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedAllergies(filteredAllergies);
  };

  const [dietaryPref, setDietaryPref] = useState([]);
  const [selectedDietaryPref, setSelectedDietaryPref] = useState([]);

  const onSuccessGetDietaryPref = (data) => {
    if (props.data.dietary_preferences_flag) {
      setCheckedBoxDietary({ checkboxDietary: true });
    }
    let diet = [];
    let dataToInsert = [];

    for (let i = 0; i < data.length; i++) {
      if (props.data.dietary_preferences.includes(data[i]._id)) {
        dataToInsert.push({ id: data[i]._id, name: data[i].title });
        diet.push({ name: data[i].title, status: true, id: data[i]._id });
      } else {
        diet.push({ name: data[i].title, status: false, id: data[i]._id });
      }
    }
    setSelectedDietaryPref(dataToInsert);
    setDietaryPref(diet);
  };

  const onErrorGetDietaryPref = () => {};
  const [allergies, setAllergies] = useState([]);
  const [selectedAllergies, setSelectedAllergies] = useState([]);

  const onSuccessAllergies = (data) => {
    // var allergiesI = [];
    // for (var i = 0; i < data.length; i++) {
    //   allergiesI.push({ name: data[i].title, status: false, id: data[i]._id });
    // }
    // setAllergies(allergiesI);
    if (props.data.allergies_flag) {
      setCheckedBoxAllergies({
        checkedBoxAllergies: true,
      });
    }
    let allergy = [];
    let dataToInsert = [];

    for (let i = 0; i < data.length; i++) {
      if (props.data.do_you_have_allergies.includes(data[i]._id)) {
        dataToInsert.push({ id: data[i]._id, name: data[i].title });
        allergy.push({ name: data[i].title, status: true, id: data[i]._id });
      } else {
        allergy.push({ name: data[i].title, status: false, id: data[i]._id });
      }
    }
    setSelectedAllergies(dataToInsert);
    setAllergies(allergy);
  };

  const onErrorGetAllergies = () => {};
  useEffect(() => {
    if (props.data.birthday_day) {
      formik.setFieldValue("birthday_day", props.data.birthday_day);
    }
    if (props.data.birthday_month) {
      formik.setFieldValue("birthday_month", props.data.birthday_month);
    }
    if (props.data.anniversary_day) {
      formik.setFieldValue("anniversary_day", props.data.anniversary_day);
    }
    if (props.data.anniversary_month) {
      formik.setFieldValue("anniversary_month", props.data.anniversary_month);
    }
    if (props.data.email) {
      formik.setFieldValue("email", props.data.email);
    }
    if (props.data.mobile_number) {
      formik.setFieldValue("mobile_number", props.data.mobile_number);
    }
    if (props.data.address) {
      formik.setFieldValue("address", props.data.address);
    }

    if (props.data.state_id) {
      onChangeCountryAvailable(parseInt(props.data.country_id));
      formik.setFieldValue("country", props.data.country);
      formik.setFieldValue("country_id", props.data.country_id);
      formik.setFieldValue("state", props.data.country);
      formik.setFieldValue("state_id", props.data.country_id);
      formik.setFieldValue("city", props.data.city);
      formik.setFieldValue("city_id", props.data.city_id);
    } else {
      props.getAllCountries(onSuccessSetDefaultCountry);
    }
    //step 2

    if (props.data.occasion.length >= 1) {
      let occ = [];
      for (let i = 0; i < props.data.occasion.length; i++) {
        occ.push(props.data.occasion[i]);
      }
      setInputFields(occ);
    }

    //step3
    daysEatOut();

    props.getCrusines(onSuccessGetCrusines, onErrorGetCruisnes);
    props.getFavPlaces(onSuccessGetFavPlaces, onErrorGetFavPlaces);
    props.getDietaryPref(onSuccessGetDietaryPref, onErrorGetDietaryPref);
    props.getAllergies(onSuccessAllergies, onErrorGetAllergies);
    // step4
    props.getFavChains(onSuccessGetFavChain, onErrorGetFavChain);
  }, []);

  const onSuccessUpdate = () => {
    props.CloseEdit();
  };

  const UpdateStep4 = () => {
    let prepareStep4Data = {};
    let selected_chain = [];
    for (let i = 0; i < selectedFavChains.length; i++) {
      selected_chain.push(selectedFavChains[i].id);
    }
    prepareStep4Data.selected_chain = selected_chain;
    props.editStep4(props.data._id, prepareStep4Data, onSuccessUpdate);
  };

  // update step 2

  const updateStep2 = () => {
    let prepareStep2Data = {};
    //prepareStep2Data = [...inputFields];

    let dataStep2 = [];
    for (let i = 0; i < inputFields.length; i++) {
      dataStep2.push({
        special_occasion: inputFields[i].special_occasion,
        special_occasion_day: inputFields[i].special_occasion_day,
        special_occasion_month: inputFields[i].special_occasion_month,
      });
    }
    prepareStep2Data = [...dataStep2];
    const formData = {
      occasion: prepareStep2Data,
    };

    props.editStep2(props.data._id, formData, onSuccessUpdate, inputFields);
  };

  const UpdateStep3 = () => {
    let prepareStep3Data = {};
    let day_you_eat_out = [];
    for (let i = 0; i < days.length; i++) {
      if (days[i].status) {
        day_you_eat_out.push(days[i].name);
      }
    }

    prepareStep3Data.day_you_eat_out = day_you_eat_out;
    let selected_cuisine = [];
    for (let i = 0; i < selectedCruisines.length; i++) {
      selected_cuisine.push(selectedCruisines[i].id);
    }

    prepareStep3Data.selected_cuisine = selected_cuisine;
    let favourite_places = [];
    for (let i = 0; i < selectedFavPlaces.length; i++) {
      favourite_places.push(selectedFavPlaces[i].id);
    }
    prepareStep3Data.favourite_places = favourite_places;

    let dietary_preferences = [];
    for (let i = 0; i < selectedDietaryPref.length; i++) {
      dietary_preferences.push(selectedDietaryPref[i].id);
    }
    prepareStep3Data.dietary_preferences = dietary_preferences;
    let do_you_have_allergies = [];
    for (let i = 0; i < selectedAllergies.length; i++) {
      do_you_have_allergies.push(selectedAllergies[i].id);
    }
    prepareStep3Data.do_you_have_allergies = do_you_have_allergies;

    prepareStep3Data.dietary_preferences_flag = checkboxDietary.checkboxDietary;

    prepareStep3Data.allergies_flag = checkedBoxAllergies.checkedBoxAllergies;
    props.editStep3(props.data._id, prepareStep3Data, onSuccessUpdate);
  };

  const [data, setData] = useState({ country: "", state: "", city: "" });

  const onChangeCountry = (e) => {
    props.getAllStateFromCountry(e.target.value, onSuccessGetAllStates);

    setData({
      ...data,
      [e.target.name]: e.target.value,
      state: "",
      city: "",
    });

    formik.setFieldValue("city", "");
    formik.setFieldValue("city_id", "");
    formik.setFieldValue("state_id", "");
    formik.setFieldValue("state", "");

    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        formik.setFieldValue("country", countries[i].name);
        formik.setFieldValue("country_id", countries[i].id);
        break;
      }
    }
  };

  const onChangeCountryAvailable = (id) => {
    props.getAllStateFromCountry(id, onSuccessGetAllStatesAvailable);
  };

  const onChangeState = (e) => {
    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);
    setData({
      ...data,
      [e.target.name]: e.target.value,
      city: "",
    });

    formik.setFieldValue("city", "");
    formik.setFieldValue("city_id", "");
    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        formik.setFieldValue("state", states[i].name);
        formik.setFieldValue("state_id", states[i].id);
        break;
      }
    }
  };

  const onChangeStateAvailable = (id) => {
    props.getAllCityFromState(parseInt(id), onSuccessGetAllCityAvailable);

    let update = data;
    update.country = parseInt(props.data.country_id);
    update.state = parseInt(props.data.state_id);
    update.city = parseInt(props.data.city_id);
    setData(update);
  };

  const onChangeCity = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    for (let i = 0; i < city.length; i++) {
      if (e.target.value === city[i].id) {
        formik.setFieldValue("city", city[i].name);
        formik.setFieldValue("city_id", city[i].id);
        break;
      }
    }
  };

  const [countries, setAllCountries] = useState([]);
  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);

  const onSuccessGetAllCountries = (data) => {
    setAllCountries(data);
  };

  const onSuccessSetDefaultCountry = (allData) => {
    setAllCountries(allData);
    if (
      props &&
      props.auth &&
      props.auth.user &&
      props.auth.user.VendorUser.country
    ) {
      for (let i = 0; i < allData.length; i++) {
        if (props.auth.user.VendorUser.country === allData[i].iso2) {
          let e = {};
          e.target = {};
          e.target.value = allData[i].id;
          e.target.name = "country";
          onChangeCountry(e, "any");
          formik.setFieldValue("country", allData[i].name);
          formik.setFieldValue("country_id", allData[i].id);

          break;
        }
      }
    }
  };

  const onSuccessGetAllStates = (data) => {
    setAllStates(data);
  };

  const onSuccessGetAllStatesAvailable = (data) => {
    setAllStates(data);
    onChangeStateAvailable(props.data.state_id);
  };

  const onSuccessGetAllCityAvailable = (data) => {
    setAllCity(data);
  };

  const onSuccessGetAllCity = (data) => {
    setAllCity(data);
  };

  useEffect(() => {
    props.getAllCountries(onSuccessGetAllCountries);
  }, []);

  return (
    <>
      <div>
        <div className="py-4 d-flex flex-wrap align-items-center justify-content-between">
          <Button
            variant="link"
            onClick={(e) => handleShowTab("1")}
            className={`px-0 mr-4 text-grayLink f15-500 ${
              ShowTab === "1" ? "active" : ""
            }`}
          >
            About
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("2")}
            className={`px-0 mr-4 text-grayLink f15-500 ${
              ShowTab === "2" ? "active" : ""
            }`}
          >
            Special occasions
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("3")}
            className={`px-0 mr-4 text-grayLink f15-500 ${
              ShowTab === "3" ? "active" : ""
            }`}
          >
            Personal preferences
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("4")}
            className={`px-0 text-grayLink f15-500 ${
              ShowTab === "4" ? "active" : ""
            }`}
          >
            Favourite hotel/restaurants
          </Button>
        </div>
        {ShowTab === "1" && (
          <div>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg={6}>
                  <div className="f12-400 w-100 mb-1">Birthday</div>
                  <div className="d-flex align-items-center pb-4">
                    <div className="">
                      <TextField
                        id="outlined-basic"
                        label="DD"
                        variant="outlined"
                        className="w-30"
                        name="birthday_day"
                        onChange={formik.handleChange}
                        value={formik.values.birthday_day}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.errors.birthday_day &&
                          formik.touched.birthday_day
                        }
                      />
                      {formik.errors.birthday_day &&
                      formik.touched.birthday_day ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.birthday_day}
                        </div>
                      ) : null}
                    </div>
                    <span className="mx-1">/</span>
                    <div>
                      <TextField
                        id="outlined-basic"
                        label="MM"
                        variant="outlined"
                        className="w-30"
                        name="birthday_month"
                        onChange={formik.handleChange}
                        value={formik.values.birthday_month}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.errors.birthday_month &&
                          formik.touched.birthday_month
                        }
                      />
                      {formik.errors.birthday_month &&
                      formik.touched.birthday_month ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.birthday_month}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="f12-400 w-100 mb-1">Anniversary</div>
                  <div className="d-flex align-items-center pb-4">
                    <div>
                      <TextField
                        label="DD"
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100"
                        name="anniversary_day"
                        onChange={formik.handleChange}
                        value={formik.values.anniversary_day}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.errors.anniversary_day &&
                          formik.touched.anniversary_day
                        }
                      />
                      {formik.errors.anniversary_day &&
                      formik.touched.anniversary_day ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.anniversary_day}
                        </div>
                      ) : null}
                    </div>
                    <span className="mx-1">/</span>
                    <div>
                      <TextField
                        label="MM"
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100"
                        name="anniversary_month"
                        onChange={formik.handleChange}
                        value={formik.values.anniversary_month}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.errors.anniversary_month &&
                          formik.touched.anniversary_month
                        }
                      />
                      {formik.errors.anniversary_month &&
                      formik.touched.anniversary_month ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.anniversary_month}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Col>
                <Col lg={6} className="pb-4">
                  <Row>
                    <Col xs={4} className="pr-0">
                      <FormControl variant="outlined" className="w-100">
                        <Select
                          disabled
                          value={state.code}
                          onChange={handleChangeCode}
                          inputProps={{
                            name: "code",
                          }}
                        >
                          <option value={state.country_code}>
                            {state.country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+
                              {getCountryCallingCode(country)})
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </Col>
                    <Col xs={8}>
                      <Form.Group>
                        <TextField
                          //type="number"
                          disabled
                          id="outlined-basic"
                          label="Phone Number"
                          variant="outlined"
                          className="w-100"
                          name="mobile_number"
                          onChange={formik.handleChange}
                          value={formik.values.mobile_number}
                          onBlur={formik.handleBlur}
                          //onInvalid={formik.errors.email && formik.touched.email}
                          isInvalid={
                            formik.errors.mobile_number &&
                            formik.touched.mobile_number
                          }
                        />
                        {formik.errors.mobile_number &&
                        formik.touched.mobile_number ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.mobile_number}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* <TextField
                    id="outlined-basic"
                    label="Phone"
                    variant="outlined"
                    className="w-100"
                    name="mobile_number"
                    onChange={formik.handleChange}
                    value={formik.values.mobile_number}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={
                      formik.errors.mobile_number &&
                      formik.touched.mobile_number
                    }
                  />
                  {formik.errors.mobile_number &&
                  formik.touched.mobile_number ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.mobile_number}
                    </div>
                  ) : null} */}
                </Col>
                <Col lg={6} className="pb-4">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    label="Email"
                    className="w-100"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.email && formik.touched.email}
                  />
                  {formik.errors.email && formik.touched.email ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </Col>
                {/* <Col lg={6} className="pb-4">
                  <TextField
                    id="outlined-basic"
                    label="Address Line 1"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.address && formik.touched.address}
                  />
                  {formik.errors.address && formik.touched.address ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.address}
                    </div>
                  ) : null}
                </Col>
                <Col lg={6} className="pb-4">
                  <TextField
                    id="outlined-basic"
                    label="Address Line 2"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.address && formik.touched.address}
                  />
                  {formik.errors.address && formik.touched.address ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.address}
                    </div>
                  ) : null}
                </Col> */}
                <Col lg={6} className="pb-4">
                  {/* <TextField
                    id="outlined-basic"
                    label="Country"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.address && formik.touched.address}
                  />
                  {formik.errors.address && formik.touched.address ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.address}
                    </div>
                  ) : null} */}
                  {/* <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Country">country</InputLabel>
                    <Select
                      value={props.country}
                      onChange={props.handleChangeCode}
                      label="country"
                      inputProps={{
                        name: "country",
                        id: "outlined-country",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="country">Country</option>
                    </Select>
                  </FormControl> */}
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Country">country</InputLabel>
                    <Select
                      value={data.country}
                      onChange={onChangeCountry}
                      label="country"
                      inputProps={{
                        name: "country",
                        id: "outlined-country",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {countries.map((country, index) => (
                        <option key={index} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.errors.country && formik.touched.country ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.country}
                    </div>
                  ) : null}
                </Col>
                <Col lg={6} className="pb-4">
                  {/* <TextField
                    id="outlined-basic"
                    label="State"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.address && formik.touched.address}
                  />
                  {formik.errors.address && formik.touched.address ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.address}
                    </div>
                  ) : null} */}
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-state">State</InputLabel>
                    <Select
                      value={data.state}
                      onChange={onChangeState}
                      label="state"
                      inputProps={{
                        name: "state",
                        id: "outlined-state",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {states.map((state, index) => (
                        <option key={index} value={state.id}>
                          {state.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.errors.state && formik.touched.state ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.state}
                    </div>
                  ) : null}
                </Col>
                <Col lg={6} className="pb-4">
                  {/* <TextField
                    id="outlined-basic"
                    label="City"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.address && formik.touched.address}
                  /> */}
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-state">city</InputLabel>
                    <Select
                      value={data.city}
                      onChange={onChangeCity}
                      label="state"
                      inputProps={{
                        name: "city",
                        id: "outlined-state",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {city.map((city, index) => (
                        <option key={index} value={city.id}>
                          {city.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.errors.city && formik.touched.city ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.city}
                    </div>
                  ) : null}
                </Col>
              </Row>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="f18-500 mr-4 px-5 py-2"
                  onClick={props.CloseEdit}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="f18-500 px-5 py-2"
                  type="submit"
                  //onClick={props.CloseEdit}
                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        )}
        {ShowTab === "2" && (
          <div>
            <Form>
              <div className="f15-700 mb-4">Special Occasion (Optional)</div>
              {inputFields.map((ocassion, index) => (
                <Row className="pb-4" key={index}>
                  <Col md={5}>
                    <TextField
                      id="outlined-basic"
                      label="Occasion"
                      variant="outlined"
                      className="w-100"
                      disabled={true}
                      value={ocassion.special_occasion}
                    ></TextField>
                  </Col>
                  <Col md={2}>
                    <TextField
                      type="number"
                      id="outlined-basic"
                      label="DD"
                      variant="outlined"
                      className="w-100"
                      disabled={true}
                      value={ocassion.special_occasion_day}
                    ></TextField>
                  </Col>
                  <Col md={2}>
                    <TextField
                      type="number"
                      id="outlined-basic"
                      label="MM"
                      variant="outlined"
                      className="w-100"
                      value={ocassion.special_occasion_month}
                      disabled={true}
                    ></TextField>
                  </Col>
                  <Col>
                    <Button
                      variant="link"
                      className="d-flex align-items-center p-0 mt-2"
                      onClick={() => removeOccasion(index)}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                        alt="Delete"
                        title="Delete"
                        className="w-20px"
                      />
                      <span className="ml-2 f12-500 opacity5">Delete</span>
                    </Button>
                  </Col>
                </Row>
              ))}
            </Form>

            {tempInput.map((ocassion, index) => (
              <Form onSubmit={(e) => onAddOccassion(e)} key={index}>
                <Row className="pb-4">
                  <Col md={5}>
                    <TextField
                      required
                      id="outlined-basic"
                      label="Occassion"
                      variant="outlined"
                      className="w-100"
                      name="special_occasion"
                      value={ocassion.special_occasion}
                      onChange={(event) => handleInputChange(index, event)}
                    ></TextField>
                  </Col>
                  <Col md={2}>
                    <TextField
                      required
                      type="number"
                      id="outlined-basic"
                      label="DD"
                      variant="outlined"
                      className="w-100"
                      name="special_occasion_day"
                      value={ocassion.special_occasion_day}
                      onChange={(event) => handleInputChange(index, event)}
                    ></TextField>
                  </Col>
                  <Col md={2}>
                    <TextField
                      required
                      type="number"
                      id="outlined-basic"
                      label="MM"
                      variant="outlined"
                      className="w-100"
                      value={ocassion.special_occasion_month}
                      onChange={(event) => handleInputChange(index, event)}
                    ></TextField>
                  </Col>
                  <Col>
                    <Button
                      variant="link"
                      className="d-flex align-items-center p-0 mt-2"
                      type="submit"
                    >
                      {/* <Image
                        src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                        alt="Delete"
                        title="Delete"
                        className="w-20px"
                      /> */}
                      <span className="ml-2 f12-500 opacity5">ADD</span>
                    </Button>
                  </Col>
                </Row>
              </Form>
            ))}

            <Button
              variant="link"
              className="d-flex align-items-center p-0 mb-4"
              onClick={() => handleAddFields()}
            >
              <Image
                src={require("../../../../assets/images/UserManagement/add-blue.svg")}
                alt="add"
                title="add"
                className="w-20px"
              />
              <span className="ml-2 f12-500 text-blue">Add Another</span>
            </Button>
            <div className="d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="f18-500 mr-4 px-5 py-2"
                onClick={props.CloseEdit}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="f18-500 px-5  py-2"
                //onClick={props.CloseEdit}
                onClick={() => updateStep2()}
              >
                Update
              </Button>
            </div>
          </div>
        )}
        {ShowTab === "3" && (
          <div>
            <Form>
              <div className="f18-700 mb-3">Days you eat out?</div>
              <div className="enMaxWidth360 mb-4">
                {days.map((day, index) => (
                  <div
                    className="enCheckWithText"
                    key={index}
                    onClick={() => onChangeDaysEatOut(day)}
                  >
                    <input type="checkbox" checked={day.status} />
                    <label>{day.name}</label>
                  </div>
                ))}
              </div>
              <div className="f18-700 mb-3">Popular Cuisines</div>
              <div className="mb-4">
                <Row>
                  {selectedCruisines.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input type="checkbox" disabled />
                        <label className="w-100">{item.name}</label>
                        <IconButton className="enCloseIcon">
                          <Image
                            src={require("../../../../assets/images/UserManagement/en_close.svg")}
                            alt="Close"
                            title="Close"
                            onClick={() => onRemoveCruises(item.id)}
                          />
                        </IconButton>
                      </div>
                    </Col>
                  ))}
                </Row>
                <div className="enScrollBox">
                  <Scrollbars style={{ width: "100%", height: 222 }}>
                    <Row className="m-0 py-3">
                      {popularCuisines.map((item, index) => (
                        <Col md={4} className="pb-3" key={index}>
                          <div
                            className="enCheckWithText w-100"
                            onChange={() =>
                              onChangeAddCrusines(item.name, item.id)
                            }
                          >
                            <input
                              type="checkbox"
                              disabled={item.status}
                              checked={item.status}
                            />
                            <label className="w-100">{item.name}</label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Scrollbars>
                </div>
              </div>
              <div className="f18-700 mb-3">Your Favorite Places</div>
              <div className="mb-4">
                <Row>
                  {selectedFavPlaces.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input type="checkbox" disabled />
                        <label className="w-100">{item.name}</label>
                        <IconButton className="enCloseIcon">
                          <Image
                            src={require("../../../../assets/images/UserManagement/en_close.svg")}
                            alt="Close"
                            title="Close"
                            onClick={() => onRemoveFavPlaces(item.id)}
                          />
                        </IconButton>
                      </div>
                    </Col>
                  ))}
                </Row>
                <div className="enScrollBox">
                  <Scrollbars style={{ width: "100%", height: 222 }}>
                    <Row className="m-0 py-3">
                      {favPlaces.map((item, index) => (
                        <Col md={4} className="pb-3" key={index}>
                          <div
                            className="enCheckWithText w-100"
                            onChange={() =>
                              onChangeAddFavPlaces(item.name, item.id)
                            }
                          >
                            <input
                              type="checkbox"
                              disabled={item.status}
                              checked={item.status}
                            />
                            <label className="w-100">{item.name}</label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Scrollbars>
                </div>
              </div>
              <div className="f18-700 mb-3">
                Do you have Dietary Preferences?
              </div>
              <div className="d-flex align-items-center pb-4">
                <div className="f16-500 mr-2">No</div>
                <Switch
                  onChange={handleChangeSwitchDietary}
                  checked={checkboxDietary.checkboxDietary}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                  // disabled={disabled === true ? true : false}
                />
                <div className="f16-500 ml-2">Yes</div>
              </div>
              {checkboxDietary.checkboxDietary && (
                <div className="mb-4">
                  <Row>
                    {selectedDietaryPref.map((item, index) => (
                      <Col md={4} key={index}>
                        <div className="enCheckWithText w-100">
                          <input type="checkbox" disabled />
                          <label className="w-100">{item.name}</label>
                          <IconButton className="enCloseIcon">
                            <Image
                              src={require("../../../../assets/images/UserManagement/en_close.svg")}
                              alt="Close"
                              title="Close"
                              onClick={() => onRemoveDietaryPref(item.id)}
                            />
                          </IconButton>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <div className="enScrollBox">
                    <Scrollbars style={{ width: "100%", height: 222 }}>
                      <Row className="m-0 py-3">
                        {dietaryPref.map((item, index) => (
                          <Col md={4} className="pb-3" key={index}>
                            <div
                              className="enCheckWithText w-100"
                              onChange={() =>
                                onChangeAddDietaryPref(item.name, item.id)
                              }
                            >
                              <input
                                type="checkbox"
                                disabled={item.status}
                                checked={item.status}
                              />
                              <label className="w-100">{item.name}</label>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Scrollbars>
                  </div>
                </div>
              )}
              <div className="f18-700 mb-3">Do you have Allergies?</div>
              <div className="d-flex align-items-center pb-4">
                <div className="f16-500 mr-2">No</div>
                <Switch
                  onChange={handleChangeSwitchAllergies}
                  checked={checkedBoxAllergies.checkedBoxAllergies}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                  // disabled={disabled === true ? true : false}
                />
                <div className="f16-500 ml-2">Yes</div>
              </div>
              {checkedBoxAllergies.checkedBoxAllergies && (
                <div className="mb-4">
                  <Row>
                    {selectedAllergies.map((item, index) => (
                      <Col md={4} key={index}>
                        <div className="enCheckWithText w-100">
                          <input type="checkbox" disabled />
                          <label className="w-100">{item.name}</label>
                          <IconButton className="enCloseIcon">
                            <Image
                              src={require("../../../../assets/images/UserManagement/en_close.svg")}
                              alt="Close"
                              title="Close"
                              onClick={() => onRemoveAllergies(item.id)}
                            />
                          </IconButton>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <div className="enScrollBox">
                    <Scrollbars style={{ width: "100%", height: 222 }}>
                      <Row className="m-0 py-3">
                        {allergies.map((item, index) => (
                          <Col md={4} className="pb-3" key={index}>
                            <div
                              className="enCheckWithText w-100"
                              onChange={() =>
                                onChangeAddAllergies(item.name, item.id)
                              }
                            >
                              <input
                                type="checkbox"
                                disabled={item.status}
                                checked={item.status}
                              />
                              <label className="w-100">{item.name}</label>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Scrollbars>
                  </div>
                </div>
              )}
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="f18-500 btn-lg mr-4 px-5 "
                  onClick={props.CloseEdit}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="f18-500 btn-lg px-5"
                  onClick={() => UpdateStep3()}
                  //onClick={props.CloseEdit}
                  //onClick={}
                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        )}
        {ShowTab === "4" && (
          <div>
            <Form>
              <div className="f18-700 mb-3">Popular Cuisines</div>
              <div className="mb-4">
                <Row>
                  {selectedFavChains.map((item, index) => (
                    <Col md={6} lg={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input type="checkbox" disabled />
                        <label className="w-100 d-flex align-items-center">
                          <Image
                            //src={require("../../../../assets/images/UserManagement/fhr2.png")}
                            src={item.icon}
                            className="enFHRIMG"
                            alt="icon"
                            title="icon"
                          />
                          {item.name}
                        </label>
                        <IconButton className="enCloseIcon">
                          <Image
                            src={require("../../../../assets/images/UserManagement/en_close.svg")}
                            alt="Close"
                            title="Close"
                            onClick={() => onRemoveFavChains(item.id)}
                          />
                        </IconButton>
                      </div>
                    </Col>
                  ))}
                </Row>
                <div className="enScrollBox">
                  <Scrollbars style={{ width: "100%", height: 222 }}>
                    <Row className="m-0 py-3">
                      {favChains.map((item, index) => (
                        <Col md={6} lg={4} className="pb-3" key={index}>
                          <div
                            className="enCheckWithText w-100"
                            onChange={() =>
                              onChangeAddFavChains(
                                item.name,
                                item.id,
                                item.icon
                              )
                            }
                          >
                            <input
                              type="checkbox"
                              checked={item.status}
                              disabled={item.status}
                            />
                            <label className="w-100 d-flex align-items-center">
                              <Image
                                src={item.icon}
                                alt="icon"
                                title="icon"
                                className="enFHRIMG"
                              />
                              {item.name}
                            </label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Scrollbars>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="f18-500 btn-lg mr-4 px-5"
                  onClick={props.CloseEdit}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="f18-500 btn-lg px-5"
                  //onClick={props.CloseEdit}
                  onClick={() => UpdateStep4()}
                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        )}
      </div>
    </>
  );
};

EditUser.propTypes = {
  auth: PropTypes.object.isRequired,
  getCrusines: PropTypes.func.isRequired,
  getFavPlaces: PropTypes.func.isRequired,
  getFavChains: PropTypes.func.isRequired,
  checkIfEmailExists: PropTypes.func.isRequired,
  checkIfPhoneExists: PropTypes.func.isRequired,
  getDietaryPref: PropTypes.func.isRequired,
  getAllergies: PropTypes.func.isRequired,
  editStep1: PropTypes.func.isRequired,
  editStep2: PropTypes.func.isRequired,
  editStep3: PropTypes.func.isRequired,
  editStep4: PropTypes.func.isRequired,
  getAllCountries: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getCrusines,
  getFavPlaces,
  getFavChains,
  checkIfEmailExists,
  checkIfPhoneExists,
  getDietaryPref,
  getAllergies,
  editStep1,
  editStep2,
  editStep3,
  editStep4,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
})(EditUser);
